import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { nomService } from '../../services/api/nom.service';
import { partnerService } from '../../services/api/partner.service';
import { reportService } from '../../services/api/report.service';
import { alertService } from '../../services/helpers/alert.service';
import { utils } from "../../services/helpers/utils";



export const PatientSubscriptions = ({ cnp, activeComponent, searchCode }) => {
    const [abonamente, setAbonamente] = useState([]);
    const navigate = useNavigate();

    const haveLocations = sessionStorage.getItem('haveLocations') === 'false' ? false : true;
    const rol = sessionStorage.getItem('rol');
    const partener = sessionStorage.getItem('idPartener');

    useEffect(() => {
        if (cnp) {
            nomService.getSubscriptions({ code: cnp })
                .then(response => {
                    if (response && response.length > 0) {
                        setAbonamente(response);
                    }
                    else {
                        alertService.error("Acest pacient nu are abonamente valide!");
                        setAbonamente([]);
                    }
                })
                .catch(error => {
                    console.log(error);

                });
        }
    }, [cnp]);


    const handleViewPreautorizare = (page, param, value) => {
        // Adminul cica nu are restrictii
        if (rol != 3) {
            handleView(page, param, value);
        }
        else {
            if (page == 'preautorizare-mm') {
                partnerService.formExists({partener : partener})
                    .then(response => {
                        if (response == false) {
                            alertService.error("Nu exista un formular de preautorizare MM");
                            return;
                        }
                        else {
                            handleView(page, param, value);
                        }

                    });
            }
        }
        
    }

    const handleView = (page, param, value) => {



        if (rol == 2) {
            alertService.error("Nu sunteti autorizat sa efectuati aceasta operatie!");
            return;
        }

        if (partener == 0) {
            alertService.error("Nu puteti efectua aceasta operatie fara a alege un partener!");
            return;
        }

        if (!haveLocations) {
            alertService.error("Nu aveti drept pe nici o locatie");
            return;
        }

        let queryString = '';

        // daca tipul lui param este obiect atunci il descompunem in cheie si valoare
        if (typeof param === 'object') {
            const keys = Object.keys(param);
            queryString = keys.map(key => `${encodeURIComponent(key)}=${encodeURIComponent(param[key])}`).join('&');
        }
        else {
            queryString = `${(param)}=${(value)}`;
        }
        var encode = {
            cnp: searchCode ?? cnp,
            activeComponent: activeComponent
        };

        var encodedString = btoa(JSON.stringify(encode));

        navigate(window.location.hash + `?q=${encodedString}`, { replace: true });
        navigate(`/dashboard/${page}?${queryString}`);
    }

    const handleExport = () => {
        if (abonamente.length == 0) {
            alertService.error("Nu exista randuri de exportat")
            return;
        }
        reportService.RaportCautarePacientAbonamente({ Code: cnp, Partener : 0 }).then((response) => {
            if (response) {
                utils.downloadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                return;
            }
        });
    }

    return (
        <>
            {abonamente &&
                <div>
                    <p className="paragraf">Abonamentele valabile ale acestui pacient:</p>
                    <table className="tbl" name="lista_abonamente" width="100%">
                            <thead>
                                <tr>
                                    <th>Nr</th>
                                    <th>Companie</th>
                                    <th width="125">Tip abonament</th>
                                    <th>Status</th>
                                    <th className="tac">Consultatie noua</th>
                                    <th className="tac">Fisa MM</th>
                                    <th className="tac">Preautorizare servicii</th>
                                    <th className="tac">Preautorizare MM</th>
                                </tr>
                            </thead>
                        <tbody>
                            {abonamente.map((abonament , index) => (
                                <tr key={index}>
                                    <td name="nr_crt" className="center first">{ index + 1}</td>
                                    <td name="firma">{abonament.firma} </td>
                                    <td name="nume_profil">
                                        {abonament.numeProfil}
                                        {abonament.firmaMaster && <span> (</span>}
                                        {abonament.firmaMaster}
                                        {abonament.firmaMaster && <span>)</span>}
                                    </td>
                                    <td name="status" className="center">{abonament.status}</td>
                                    <td className="center">
                                        <a className="icon adauga m0auto"
                                           
                                            onClick={() => handleView("consultatie", { pacient: abonament.pacId, contract:  abonament.idContracte })}
                                            title="Adauga consultatie" name="adaugare-consultatie">Adauga consultatie
                                        </a>
                                    </td>
                                    <td className="center">
                                        <a className="icon deschide m0auto"
                                            onClick={() => handleView("fisa-mm", { pacient: abonament.pacId, contract: abonament.idContracte })}
                                            title="Deschide fisa MM" name="deschide-fisa">
                                            Deschide fisa MM
                                        </a>
                                    </td>
                                    <td className="center"><a className="icon preautorizarec m0auto"
                                        onClick={() => handleView("preautorizare", { pacient: abonament.pacId, contract: abonament.idContracte })}
                                        title="Adaugare cerere de preautorizare" name="adaugare-preautorizare">
                                        Cere preautorizare cons.</a>
                                    </td>
                                    <td className="center">
                                        <a className="icon preautorizarem m0auto"
                                            onClick={() => handleViewPreautorizare("preautorizare-mm", { pacient: abonament.pacId, contract: abonament.idContracte })}
                                            title="Adaugare cerere de preautorizare MM"
                                            name="adaugare-preautorizare-mm">
                                            Cere preautorizare MM</a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div name="export">
                        <button name="btn-export" className="btn" onClick={ handleExport }>Export</button>
                    </div>
                </div>
            }
        </>
    );
};